import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { QrCode, UserPlus, Package, ShoppingCart, Users, Eye } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { NewVisitModal } from '@/components/visits/NewVisitModal';

const actions = [
  { icon: QrCode, label: 'QR Tarama', color: 'bg-accent', path: '/qr-scan' },
  { icon: Users, label: 'Ziyaret Başlat', color: 'bg-blue-500', action: 'visit' },
  { icon: Eye, label: 'Ziyaretler', color: 'bg-purple-500', path: '/visits' },
  { icon: UserPlus, label: 'Yeni Müşteri', color: 'bg-success', path: '/customers' },
  { icon: Package, label: 'Paket Oluştur', color: 'bg-warning', path: '/packages' },
  { icon: ShoppingCart, label: 'Satış Başlat', color: 'bg-destructive', path: '/sales/new' },
];

export const QuickActions = () => {
  const navigate = useNavigate();
  const [showNewVisitModal, setShowNewVisitModal] = useState(false);

  const handleActionClick = (action: any) => {
    if (action.action === 'visit') {
      setShowNewVisitModal(true);
    } else if (action.path) {
      navigate(action.path);
    }
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl md:text-3xl font-bold mb-2 text-foreground">Hızlı İşlemler</h2>
        <p className="text-lg text-muted-foreground">Sık kullanılan özellikler ve fonksiyonlar</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4 lg:gap-6">
        {actions.map((action, index) => (
          <Button
            key={index}
            variant="outline"
            className="h-20 sm:h-24 flex-col gap-2 sm:gap-3 hover-lift glass-panel hover:glass-panel-strong p-3 sm:p-4 transition-all duration-200 hover:scale-105 no-zoom touch-target mobile-button"
            size="lg"
            onClick={() => handleActionClick(action)}
          >
            <div className={`w-8 h-8 sm:w-10 sm:h-10 rounded-xl ${action.color} flex items-center justify-center flex-shrink-0 shadow-lg`}>
              <action.icon className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
            </div>
            <span className="text-xs sm:text-sm font-semibold leading-tight text-center break-words px-1">{action.label}</span>
          </Button>
        ))}
      </div>

      <NewVisitModal
        open={showNewVisitModal}
        onOpenChange={setShowNewVisitModal}
      />
    </div>
  );
};